export const ACTION_TYPE = {
  INITIAL_DATA_FETCH: "INITIAL_DATA_FETCH",
  FILTER_CATEGORY: "FILTER_CATEGORY",
  ADD_TO_HISTORY: "ADD_TO_HISTORY",
  ADD_TO_LIKES: "ADD_TO_LIKES",
  ADD_TO_WATCH_LATER: "ADD_TO_WATCH_LATER",
  ADD_TO_PLAYLISTS: "ADD_TO_PLAYLISTS",
  ADD_VIDEO_TO_PLAYLIST: "ADD_VIDEO_TO_PLAYLIST",
  USER_LOGOUT: "USER_LOGOUT",
  SEARCH: "SEARCH",
  CLEAR_HISTORY: "CLEAR_HISTORY",
};
